import { resource } from "@yulintu/freesia-bootstrap";
const json5 = require('json5')
export const get = async (path) => {
    return new Promise((resolve, reject) => {
        fetch(resource(path))
            .then(resp => {
                return resp.text()
            })
            .then(resp => {
                resolve(json5.parse(resp)) 
            })
            .catch((err) => {
                console.warn(`未找到配置文件：${path},${err?.message}`)
            })
    })
}

export const loadAppJSON = async function (path) {
    return await fetch(resource(path)).then(r => r.text())
}

export const loadVariablesJSON = async function () {
    return await get('/config/variables.json');
}